module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTU0OS43IDEwOC4zbDM1MS44IDI1Ni40YzIyLjUgMTYuNCAzMS45IDQ1LjQgMjMuMyA3MmwtMTM0LjQgNDE0LjhBNjQuMiA2NC4yIDAgMCAxIDcyOS40IDg5NkgyOTQuNmE2NC4yIDY0LjIgMCAwIDEtNjEtNDQuNWwtMTM0LjQtNDE0LjhhNjQuNSA2NC41IDAgMCAxIDIzLjMtNzJMNDc0LjIgMTA4LjNhNjQgNjQgMCAwIDEgNzUuNSAweiBtLTM4OS41IDMwOC41bDEzNC40IDQxNC44aDQzNC44bDEzNC40LTQxNC44TDUxMiAxNjAuNCAxNjAuMiA0MTYuOHoiIGZpbGw9IiMwIiBwLWlkPSIxNjMyIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Polygon-outlined.svg
// module id = pniQ
// module chunks = 74